import React from 'react'
import { Card } from 'antd'
import AttemptsHistogram from './AttemptsHistogram'
import { useParams } from 'react-router'

const AttemptsHistogramCard = () => {
    const { token } = useParams()

    return (
        <Card title='Number of Attempts'>
            <AttemptsHistogram token={token} />
        </Card>
    )
}

export default AttemptsHistogramCard
